export default __webpack_public_path__ + "static/media/Classical.92353a1c.mp3";